import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import WorkspaceLogo from 'components/common/WorkspaceLogo';

const AuthLayout = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="auth-page font-nunito min-h-screen flex">
      {/* Left branding panel */}
      <div className="auth-brand-panel hidden lg:flex w-[280px] shrink-0 flex-col justify-between px-8 py-10">
        <div>
          <WorkspaceLogo
            title={t('dashboard.sidebarTitle')}
            subtitle={t('dashboard.sidebarSubtitle')}
          />
          <div className="mt-16">
            <p className="auth-subtitle font-command-label text-[10px] uppercase tracking-[0.22em] mb-4">
              {t('auth.appTagline')}
            </p>
            <h2
              className="font-command-display text-3xl font-bold leading-tight"
              style={{ color: 'var(--workspace-text)' }}
            >
              {t('auth.loginTitle')}
            </h2>
          </div>
          <div className="mt-10 space-y-4">
            {[t('nav.dashboard'), t('nav.management'), t('nav.reports')].map(item => (
              <div key={item} className="flex items-center gap-3">
                <span className="auth-accent-dot h-1.5 w-1.5 rounded-full shrink-0" />
                <span className="auth-label font-command-label text-[10px] uppercase tracking-[0.18em]">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
        <p className="auth-subtitle font-command-label text-[10px] uppercase tracking-widest">
          &copy; {new Date().getFullYear()} GreenHouse App
        </p>
      </div>

      {/* Right form panel */}
      <div className="auth-panel-right flex flex-1 flex-col items-center justify-center min-h-screen px-6 py-12 lg:px-16">
        {/* Mobile logo — only visible below lg */}
        <div className="mb-8 lg:hidden">
          <WorkspaceLogo
            title={t('dashboard.sidebarTitle')}
            subtitle={t('dashboard.sidebarSubtitle')}
          />
        </div>

        <div className="dashboard-surface border rounded-xl p-8 w-full max-w-sm">{children}</div>
      </div>
    </div>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default AuthLayout;
